import { useCallback, useEffect } from 'react';

function useClickOutside(target, callback) {
    const onClick = useCallback((event) => {
        const eventTarget = event.target;
        if (target && eventTarget && !target.contains(eventTarget) && target != eventTarget) {
            callback(event);
        }
    }, [target, callback]);
    useEffect(() => {
        window.addEventListener("click", onClick);
        return () => window.removeEventListener("click", onClick);
    }, [onClick]);
}

export { useClickOutside };
//# sourceMappingURL=clickOutside.js.map
